export const OrganizationStatuses = {
  PENDING_ACTIVATION: "PENDING_ACTIVATION",
  DENIED: "DENIED",
  DEACTIVATED: "DEACTIVATED",
  ACTIVE: "ACTIVE"
};
